<template>
  <div>
    <div class="Img">
      <img src="@/assets/pc/BkHash/zanwushuju.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        
    };
  },
};
</script>

<style lang="less" scoped>
.Img {
  width: 100%;
  height: 770px;
  text-align: center;
  img {
    margin-top: 200px;
  }
}
</style>